define('BluePoint.OrderTotalFix.CheckoutContainer',
    [],
    function () {

        'use strict';

        return {
            container: null
        };
    }
);
